// services/apiService.js
import axios from 'axios';
import config from '../config';
// import { encryptToken } from '../utils/criptografia';
import { toast } from 'react-toastify';

// Criar uma instância axios configurada
const api = axios.create({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para adicionar o token de autenticação em todas as requisições
api.interceptors.request.use(
  (reqConfig) => {
    const token = localStorage.getItem(config.storage.token);
    if (token) {
      reqConfig.headers.Authorization = `Bearer ${token}`;
    }
    return reqConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas e erros
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Se o erro for de autenticação (401), redirecionar para o login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(config.storage.token);
      localStorage.removeItem(config.storage.dadosUsuario);
      window.location.href = config.routes.login;
    }
    return Promise.reject(error);
  }
);

// Funções para autenticação
export const authService = {
  // Realizar login
  login: async (cnpj, usuario, senha, origem) => {
    try {

      const token = senha;
      if (token) {
        // Extrair os 3 primeiros dígitos
        const tresPrimeiros = cnpj.substring(0, 3);
        // Extrair os 3 últimos dígitos
        const tresUltimos = cnpj.substring(cnpj.length - 3);
        // pegar o dia do mes
        const dia = new Date();

        // gerar a contra-senha
        let contraSenha = (Number(tresPrimeiros) * Number(tresUltimos));

        if (origem === '0') {
          contraSenha = contraSenha + Number(dia.getDate());
        }

        if (Number(contraSenha) !== Number(senha)) {
          const retorno = { "id": 0, "nome": "Financeiro", "token": "0" };
          localStorage.setItem(config.storage.token, '');
          localStorage.setItem(config.storage.dadosUsuario, '');
          localStorage.setItem(config.storage.idUsuario, 0);
          localStorage.setItem(config.storage.origem, '0');
          return retorno;
        } else {
          const retorno = { "id": 1, "nome": "Financeiro", "token": senha };
          // Armazenar token e dados do usuário
          localStorage.setItem(config.storage.token, token);
          localStorage.setItem(config.storage.dadosUsuario, JSON.stringify(retorno));
          localStorage.setItem(config.storage.idUsuario, 1);
          localStorage.setItem(config.storage.origem, origem);
          return retorno;
        }

      } else {
        alert('Dados não conferem...Token não encontrado na resposta');
        throw new Error('Token não encontrado na resposta');
      }
    } catch (error) {
      if (error.response) {
        // Erro de resposta da API
        toast.error(`Erro no login: 'Dados não conferem'}`);
      } else if (error.request) {
        // Erro de requisição sem resposta
        toast.error('Não foi possível conectar ao servidor. Verifique sua conexão.');
      } else {
        // Outros erros
        toast.error(`Erro no login: ${error.message}`);
      }
      throw error;
    }
  },

  // Verificar se o usuário está autenticado
  isAuthenticated: () => {
    return !!localStorage.getItem(config.storage.token);
  },

  // Fazer logout
  logout: () => {
    localStorage.removeItem(config.storage.token);
    localStorage.removeItem(config.storage.dadosUsuario);
    localStorage.removeItem(config.storage.idUsuario);
    localStorage.removeItem(config.storage.origem);
  }
};

// Funções para boletos
export const boletosService = {
  // Listar todos os boletos
  listarBoletos: async (cnpj) => {
    try {
      const response = await api.post(config.api.endpoints.boletos.listar,
        {
          "cnpj": cnpj,
          "senha": localStorage.getItem(config.storage.token),
          "origem": localStorage.getItem(config.storage.origem)
        });
      return response?.data;
    } catch (error) {
      throw error;
    }
  },

  // Baixar um boleto específico
  baixarBoleto: async (id) => {
    try {
      const response = await api.get(config.api.endpoints.boletos.baixar(id), {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

// Funções para notas fiscais
export const notasFiscaisService = {
  // Listar todas as notas fiscais
  listarNotasFiscais: async (cnpj) => {
    try {
      const response = await api.post(config.api.endpoints.notasFiscais.listar,
        {
          "cnpj": cnpj,
          "senha": localStorage.getItem(config.storage.token),
          "origem": localStorage.getItem(config.storage.origem)
        });
      return response?.data;
    } catch (error) {
      throw error;
    }
  },

  // Baixar uma nota fiscal específica
  baixarNotaFiscal: async (id) => {
    try {
      const response = await api.get(config.api.endpoints.notasFiscais.baixar(id), {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  abrirPdfNFSe: async (id) => {
    try {
      const consulta = await api.get('/nfsePdf/' + id);
      return consulta;
    } catch (error) {
      throw error;
    }
  }
};

export default { authService, boletosService, notasFiscaisService };